"use strict";

var e = require("./_rollupPluginBabelHelpers-47e7ccca.js"),
    n = require("react"),
    t = require("styled-components"),
    o = require("prop-types"),
    a = require("./constants-79aa80eb.js"),
    i = require("./form-style-65868774.js"),
    r = require("./tooltip.js");

function u(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

var l,
    s = u(n),
    I = u(t),
    M = u(o),
    c = ["elemento", "name"],
    g = ["elemento", "name", "placeholder", "tipo", "testId"],
    d = "\n  font-size: 14px;\n  transform: translate(8px, -10px);\n",
    A = "\n  background-image: url(".concat("data:image/svg+xml;base64,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", ");\n  background-position-x: 10px;\n  background-position-y: 12px;\n  background-repeat: no-repeat;\n"),
    p = I.default.div(l || (l = e._taggedTemplateLiteral(["\n  position: relative;\n  ", "\n\n  @media (max-width: ", ") {\n    width: 100%;\n\n    ", "\n  }\n\n  input:focus + label,\n  input:active + label,\n  textarea:focus + label,\n  textarea:active + label {\n    ", "\n  }\n\n  input,\n  textarea {\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n\n  input {\n    height: 40px;\n  }\n\n  label {\n    ", "\n    ", "\n  }\n\n  .input__mensagem--erro {\n    ", "\n    ", "\n  }\n\n  .input__tip {\n    ", "\n  }\n\n  .input--icone {\n    ", "\n    ", "\n    ", "\n  }\n  \n  .icone--senha {\n    ", "\n    background-repeat: no-repeat;\n    cursor: pointer;\n    height: 11px;\n    top: 15px;\n    transform: translate(", ", 0);\n    width: 20px;\n    ", "\n  }\n\n  .input--info {\n    height: 20px;\n    text-align: left;\n  }\n"])), function (e) {
  return e.column ? "width: calc(100%/".concat(e.column, ");") : "width: 100%;";
}, a.mediaQuery.mobile, function (e) {
  return e.hasSpaceBottom && "\n  padding-bottom: 20px;\n";
}, d, i.defaultInputStyle, function (e) {
  return e.disabled && i.disableInputStyle;
}, function (e) {
  return e.elemento === T.ELEMENTO_TEXTAREA && "\n  height: 100px;\n  padding-top: 8px;\n  resize: none;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n";
}, function (e) {
  return e.erro && i.erroInput;
}, function (e) {
  return e.sucesso && i.sucessoInput;
}, function (e) {
  return e.autoComplete && "\n  background-color: #efefef;\n  border: none;\n  border-radius: 3px;\n  padding-left: 30px;\n  position: relative;\n  transition: all 0s ease;\n\n  &:focus,\n  &:active {\n    background-image: unset;\n    padding-left: 10px;\n    &::placeholder {\n      color: #efefef;\n    }\n  }\n";
}, function (e) {
  return !e.value && e.autoComplete && A;
}, function (e) {
  return e.autoComplete ? i.autoCompleteLabelStyle : i.defaultLabelStyle;
}, function (e) {
  return !!e.value && d;
}, i.defaultMensagemErro, function (e) {
  return e.erro && "opacity: 1;";
}, i.tip, i.defaultIcones, function (e) {
  return e.erro && i.erroInputIcone;
}, function (e) {
  return e.sucesso && i.sucessoInputIcone;
}, i.defaultIcones, function (e) {
  return e.erro || e.sucesso ? "-25px" : "0";
}, function (e) {
  return e.visualizarSenha ? i.senhaIconeHide : i.senhaIcone;
}),
    T = function (n) {
  e._inherits(o, n);

  var t = e._createSuper(o);

  function o(n) {
    var a;
    return e._classCallCheck(this, o), (a = t.call(this, n)).state = {
      visualizarSenha: n.tipo !== o.TIPO_SENHA
    }, a;
  }

  return e._createClass(o, [{
    key: "onKeyPress",
    value: function value(e) {
      this.props.onPressEnter && (e.key && "Enter" === e.key || e.which && 13 === e.which || e.keyCode && 13 === e.keyCode) && this.props.onPressEnter(e), this.props.onKeyPress(e);
    }
  }, {
    key: "getIcones",
    value: function value(e) {
      return this.props.erro ? s.default.createElement("i", {
        className: "input--icone icone--erro"
      }) : e ? s.default.createElement("i", {
        className: "input--icone icone--sucesso"
      }) : void 0;
    }
  }, {
    key: "getMensagemErro",
    value: function value(e) {
      if (e) return s.default.createElement("p", {
        className: "input__mensagem--erro"
      }, e);
    }
  }, {
    key: "renderTip",
    value: function value() {
      return s.default.createElement("p", {
        className: "input__tip"
      }, this.props.tip);
    }
  }, {
    key: "permitirVisualizacaoSenha",
    value: function value() {
      this.setState(function (e) {
        return {
          visualizarSenha: !e.visualizarSenha
        };
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e = this.props,
          n = e.autoComplete,
          t = e.autoFocus,
          a = e.column,
          i = e.disabled,
          u = e.elemento,
          l = e.erro,
          I = e.isPassword,
          M = e.hasSpaceBottom,
          c = e.label,
          g = e.name,
          d = e.placeholder,
          A = e.onBlur,
          T = e.onChange,
          N = e.onFocus,
          C = e.onKeyDown,
          D = e.readOnly,
          E = e.sucesso,
          f = e.testId,
          m = e.tip,
          y = e.tipo,
          j = e.tooltip,
          w = e.value;
      return s.default.createElement(p, {
        autoComplete: n,
        column: a,
        disabled: i,
        elemento: u,
        erro: l,
        isEmpty: !0,
        isPassword: I,
        hasSpaceBottom: M,
        sucesso: E,
        value: !!w,
        visualizarSenha: this.state.visualizarSenha
      }, s.default.createElement(o.TEXT_AREA, {
        autoFocus: t,
        disabled: i,
        elemento: u,
        label: c,
        name: g,
        onBlur: A,
        onChange: T,
        onFocus: N,
        onKeyDown: C,
        onKeyPress: this.onKeyPress.bind(this),
        placeholder: d,
        readOnly: D,
        value: w
      }), s.default.createElement(o.INPUT, {
        autoFocus: t,
        testId: f,
        disabled: i,
        elemento: u,
        label: c,
        name: g,
        placeholder: d,
        onBlur: A,
        onChange: T,
        onFocus: N,
        onKeyDown: C,
        onKeyPress: this.onKeyPress.bind(this),
        readOnly: D,
        tipo: this.state.visualizarSenha && I ? o.TIPO_TEXTO : y,
        value: w
      }), s.default.createElement("label", {
        htmlFor: g,
        onClick: N
      }, c), j && s.default.createElement(r, {
        erro: !!l,
        mensagem: j,
        sucesso: E
      }), y === o.TIPO_SENHA && I && s.default.createElement("i", {
        className: "icone--senha",
        onClick: this.permitirVisualizacaoSenha.bind(this)
      }), s.default.createElement("div", {
        className: "input--info"
      }, this.getIcones(E), l && this.getMensagemErro(l), m && !l && !E && this.renderTip()));
    }
  }]), o;
}(n.Component);

e._defineProperty(T, "TIPO_EMAIL", "email"), e._defineProperty(T, "TIPO_TEL", "tel"), e._defineProperty(T, "TIPO_SENHA", "password"), e._defineProperty(T, "TIPO_TEXTO", "text"), e._defineProperty(T, "ELEMENTO_INPUT", "input"), e._defineProperty(T, "ELEMENTO_TEXTAREA", "textarea"), e._defineProperty(T, "TIPOS_VALIDOS", [T.TIPO_EMAIL, T.TIPO_TEL, T.TIPO_SENHA, T.TIPO_TEXTO]), e._defineProperty(T, "ELEMENTOS", [T.ELEMENTO_INPUT, T.ELEMENTO_TEXTAREA]), e._defineProperty(T, "TEXT_AREA", function (n) {
  var t = n.elemento,
      o = n.name,
      a = e._objectWithoutProperties(n, c);

  return t === T.ELEMENTO_TEXTAREA ? s.default.createElement("textarea", e._extends({
    id: o,
    name: o,
    type: "textarea"
  }, a)) : null;
}), e._defineProperty(T, "INPUT", function (n) {
  var t = n.elemento,
      o = n.name,
      a = n.placeholder,
      i = n.tipo,
      r = n.testId,
      u = e._objectWithoutProperties(n, g);

  return t === T.ELEMENTO_INPUT ? s.default.createElement("input", e._extends({
    id: o,
    name: o,
    placeholder: a,
    type: i,
    "data-testid": r
  }, u)) : null;
}), e._defineProperty(T, "propTypes", {
  autoComplete: M.default.bool,
  autoFocus: M.default.bool,
  column: M.default.number,
  disabled: M.default.bool,
  elemento: M.default.oneOf(T.ELEMENTOS).isRequired,
  erro: M.default.string,
  isPassword: M.default.bool,
  hasSpaceBottom: M.default.bool,
  label: M.default.string,
  name: M.default.string.isRequired,
  placeholder: M.default.string,
  onBlur: M.default.func,
  onChange: M.default.func.isRequired,
  onPressEnter: M.default.func,
  onFocus: M.default.func,
  onKeyDown: M.default.func,
  onKeyPress: M.default.func,
  sucesso: M.default.bool,
  testId: M.default.string,
  tip: M.default.string,
  tipo: M.default.oneOf(T.TIPOS_VALIDOS).isRequired,
  tooltip: M.default.string,
  value: M.default.string.isRequired
}), e._defineProperty(T, "defaultProps", {
  autoComplete: !1,
  autoFocus: !1,
  column: 1,
  disabled: !1,
  elemento: T.ELEMENTO_INPUT,
  erro: null,
  isPassword: !1,
  hasSpaceBottom: !0,
  label: null,
  name: "",
  placeholder: "",
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onPressEnter: void 0,
  readOnly: !1,
  sucesso: !1,
  testId: "",
  tip: "",
  tipo: T.TIPO_TEXTO,
  tooltip: null,
  value: ""
}), module.exports = T;